import * as yup from "yup";
import { Quote } from "../../../models/quote.model";

export const quoteInitialValues: Partial<Quote> = {
  status: "",
  date: new Date().toISOString().split("T")[0],
  serviceFormURL: undefined,
  titleZip: "",
  titleState: "",
  county: "",
  city: "",
  transactionType: "",
  outsideCityLimits: false,
  driverLastName: "",
  vinNumber: "",
  commercialUse: "No",
  modelYear: "",
  make: "",
  bodyStyle: "",
  odometer: "",
  cylindars: "",
  horsepower: "",
  cc: undefined,
  rimSize: "",
  numTires: "",
  numAxles: "",
  registrationMonths: "",
  previousRegistrations: undefined,
  weight: "",
  registeredWeight: undefined,
  gvw: undefined,
  gvwr: undefined,
  fuelType: undefined,
  evTaxCredit: "Do not apply",
  taxCreditAmount: undefined,
  mpg: "",
  highwayMpg: "",
  combinedMpg: "",
  color: "",
  length: undefined,
  squareFootage: undefined,
  activeMilitary: "No",
  mcoTitle: "Title",
  plateTransfer: "Yes",
  plateNumber: "",
  plateExpiration: "",
  plateType: "Yes",
  lien: "No",
  tradeIn: false,
  tradeInVehicleType: undefined,
  tradeInVehicleSubType: undefined,
  tradeInModelYear: undefined,
  purchaseDate: undefined,
  msrp: "",
  basePrice: undefined,
  tradeInValue: "",
  dealerRebate: undefined,
  manufacturerRebate: undefined,
  discount: undefined,
  docFees: "",
  warrants: undefined,
  extendedWarranties: undefined,
  addOns: undefined,
  protectionPackages: undefined,
  theftProtection: undefined,
  insurancePackages: undefined,
  dealerInventoryTaxes: undefined,
  deliveryFees: "",
  taxesPaidDealerState: undefined,
  dealerServiceFee: undefined,
  capCostReduction: undefined,
  leaseMonthlyPayment: undefined,
  leaseNumberPayments: undefined,
};

export const QuoteSchemaYup = yup.object().shape({
  status: yup.string().optional(),
  date: yup.string().optional(),
  serviceFormURL: yup.string().url("Must be a valid URL").optional(),
  titleZip: yup.string().optional(),
  titleState: yup.string().optional(),
  county: yup.string().optional(),
  city: yup.string().optional(),
  transactionType: yup.string().optional(),
  outsideCityLimits: yup.boolean().optional(),
  driverLastName: yup.string().optional(),
  vinNumber: yup.string().optional(),
  commercialUse: yup.string().oneOf(["Yes", "No"]).optional(),
  modelYear: yup.string().optional(),
  make: yup.string().optional(),
  bodyStyle: yup.string().optional(),
  odometer: yup.string().optional(),
  cylindars: yup.string().optional(),
  horsepower: yup.string().optional(),
  cc: yup.string().optional(),
  rimSize: yup.string().optional(),
  numTires: yup.string().optional(),
  numAxles: yup.string().optional(),
  registrationMonths: yup.string().optional(),
  previousRegistrations: yup.string().optional(),
  weight: yup.string().optional(),
  registeredWeight: yup.string().optional(),
  gvw: yup.string().optional(),
  gvwr: yup.string().optional(),
  fuelType: yup.string().optional(),
  evTaxCredit: yup
    .string()
    .oneOf(["Apply credit to taxable amount", "Do not apply"])
    .optional(),
  taxCreditAmount: yup.string().optional(),
  mpg: yup.string().optional(),
  highwayMpg: yup.string().optional(),
  combinedMpg: yup.string().optional(),
  color: yup.string().optional(),
  length: yup.string().optional(),
  squareFootage: yup.string().optional(),
  activeMilitary: yup.string().oneOf(["Yes", "No"]).optional(),
  mcoTitle: yup.string().oneOf(["MCO", "Title"]).optional(),
  plateTransfer: yup.string().oneOf(["Yes", "No"]).optional(),
  plateNumber: yup.string().optional(),
  plateExpiration: yup.string().optional(),
  plateType: yup.string().oneOf(["Yes", "Commercial"]).optional(),
  lien: yup.string().oneOf(["Yes", "No"]).optional(),
  tradeIn: yup.boolean().optional(),
  tradeInVehicleType: yup.string().optional(),
  tradeInVehicleSubType: yup.string().optional(),
  tradeInModelYear: yup.string().optional(),
  purchaseDate: yup.string().optional(),
  msrp: yup.string().optional(),
  basePrice: yup.string().optional(),
  tradeInValue: yup.string().optional(),
  dealerRebate: yup.string().optional(),
  manufacturerRebate: yup.string().optional(),
  discount: yup.string().optional(),
  docFees: yup.string().optional(),
  warrants: yup.string().optional(),
  extendedWarranties: yup.string().optional(),
  addOns: yup.string().optional(),
  protectionPackages: yup.string().optional(),
  theftProtection: yup.string().optional(),
  insurancePackages: yup.string().optional(),
  dealerInventoryTaxes: yup.string().optional(),
  deliveryFees: yup.string().optional(),
  taxesPaidDealerState: yup.string().optional(),
  dealerServiceFee: yup.string().optional(),
  capCostReduction: yup.string().optional(),
  leaseMonthlyPayment: yup.string().optional(),
  leaseNumberPayments: yup.string().optional(),
});
